import CommonEnvs from './common/env';
import { stageUrls } from './constants/stage-constant';

const createApiConfig = (baseUrl: string) => ({
  base_url: baseUrl,
  useCustomHeaders: true,
});

export default {
  ...CommonEnvs,
  API: {
    'auth-api': createApiConfig(stageUrls.authServiceUrl),
    'provider-api': createApiConfig(stageUrls.providerServiceUrl),
    'appointment-api': createApiConfig(stageUrls.appointmentServiceUrl),
    'macros-api': createApiConfig(stageUrls.macrosServiceUrl),
    'ehr-api': createApiConfig(stageUrls.ehrServiceUrl),
    'transcript-api': createApiConfig(stageUrls.transcriptServiceUrl),
    'graphql-api': createApiConfig(stageUrls.graphqlApiUrl),
    'gwp-api': createApiConfig(stageUrls.gwpServiceUrl),
    'text-expander-api': createApiConfig(stageUrls.textExpanderServiceUrl),
    'signup-api': { base_url: stageUrls.signupServiceUrl },
    'nrt-api': { base_url: stageUrls.nrtServerUrl },
    'user-management-api': { base_url: stageUrls.userManagementServiceUrl },
    'sso-api': { base_url: stageUrls.ssoServiceUrl },
  },
  URL: {
    'signup-url': 'https://g-stage-go.augmedix.com/signup',
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyBF58cPweWkihDaG_YBSmZsKCdiCqRj0k8',
    authDomain: 'gcp-stage-env.firebaseapp.com',
    projectId: 'gcp-stage-env',
    storageBucket: 'gcp-stage-env.firebasestorage.app',
    messagingSenderId: '126333463693',
    appId: '1:126333463693:web:e8bb3d9a9c583e7b8686c4',
    measurementId: 'G-33BS8CPL0Q',
  },
};
